import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgProcessing = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M8.049 14.349q-1.622 0-2.96-.67a6.3 6.3 0 0 1-2.222-1.87q-.885-1.201-1.156-2.778H.509q-.397 0-.488-.295-.079-.306.136-.612l1.815-2.551q.237-.34.578-.329t.567.329l1.848 2.551q.215.306.125.612-.091.295-.488.295h-1.19a4.5 4.5 0 0 0 .918 1.814q.669.794 1.621 1.259.964.465 2.098.465.816 0 1.462-.25.658-.261 1.27-.737.33-.25.692-.272.374-.023.669.295.294.317.204.714-.08.397-.488.726a5.6 5.6 0 0 1-1.746.964 6.4 6.4 0 0 1-2.063.34M8.026 1.65q1.61 0 2.948.68a6.1 6.1 0 0 1 2.222 1.871q.886 1.19 1.168 2.767h1.134q.396 0 .476.306.09.295-.136.6l-1.814 2.563q-.239.34-.578.329-.34-.023-.567-.329l-1.837-2.562q-.216-.307-.136-.601.09-.306.487-.306h1.259a4.4 4.4 0 0 0-.918-1.803A4.7 4.7 0 0 0 10.1 3.906a4.7 4.7 0 0 0-2.075-.465q-.828 0-1.474.25-.646.249-1.258.726-.34.249-.703.283-.363.022-.67-.306a.76.76 0 0 1-.203-.703q.08-.408.487-.726a5.6 5.6 0 0 1 1.746-.963 6.3 6.3 0 0 1 2.075-.352"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgProcessing);
export default ForwardRef;
